<script>
export default {
  name: "AdvertContentManage",
  props: {
    advertUuid: String,
  },
  data() {
    return {
      busy: {
        all: false,
        videoPreview: false,
      },

      filter: {
        advert_uuid: null,
        current_page: null,
        roles: null,
      },

      form: {
        videoFile: null,
        photoFile: null,
      },

      items: {
        advert_contents: [],
      },

      item: {
        advert: {},
        filePath: "",
        fileUrl: "",
      },

      fields: {
        advert_contents: [
          {
            key: "preview",
            label: "preview",
            class: "align-middle",
          },
          {
            key: "file_type",
            label: "file_type",
            class: "align-middle",
          },
          // {
          //   key: "file_extension",
          //   label: "file_extension",
          //   class: "align-middle",
          // },
          {
            key: "file_name",
            label: "file_name",
            class: "align-middle",
          },
          {
            key: "actions",
            label: "Действия",
            class: "actions align-middle text-center",
          },
        ],
      },
    }
  },
  watch: {
    "form.videoFile"(newValue) {
      if (newValue) {
        this.uploadContentFile(newValue, "video")
      }
    },
    "form.photoFile"(newValue) {
      if (newValue) {
        this.uploadContentFile(newValue, "photo")
      }
    },
  },
  computed: {
    getAdvert() {
      return this.item.advert
    },
    getAdvertContents() {
      return this.items.advert_contents
    },
    getFields() {
      return this.fields.advert_contents
    },
    isBusy() {
      return this.busy.all
    },
    isBusyVideoPreview() {
      return this.busy.videoPreview
    },
  },
  methods: {
    makeToast(body = "Ничего не произошло", variant = "success", title = "Уведомление") {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-center",
      })
    },
    uploadContentFile(file, type) {
      this.busy.all = true
      const formData = new FormData()
      formData.set("file", file)
      formData.set("advert_uuid", this.advertUuid)
      formData.set("type", type)
      axios.post("/webapi/advert/content", formData).finally(() => {
        this.fetchAdvertContents()
      })
    },
    deleteContentFile(uuid) {
      this.busy.all = true
      axios.delete("/webapi/advert/content/" + uuid).finally(() => {
        this.fetchAdvertContents()
      })
    },
    fetchAdvert() {
      axios
        .get("/webapi/advert/" + this.filter.advert_uuid)
        .then(({data}) => {
          this.item.advert = data.data
        })
        .catch(() => {
          this.makeToast("Что-то пошло не так", "danger")
        })
    },
    fetchAdvertContents() {
      this.busy.all = true
      axios
        .get("/webapi/advert/content/manage", {
          params: this.filter,
        })
        .then(({data}) => {
          this.items.advert_contents = data.data
          this.busy.all = false
        })
        .catch(() => {
          this.makeToast("Что-то пошло не так", "danger")
          this.busy.all = false
        })
    },
    videoPreview(fileUrl) {
      this.busy.videoPreview = true
      this.item.fileUrl = fileUrl
      this.$bvModal.show("modal-video-preview")
    },
  },
  created() {
    this.filter.advert_uuid = this.advertUuid
    this.fetchAdvert()
    this.fetchAdvertContents()
  },
}
</script>

<style></style>
